"use client";
import {
  CompositeContextProvider,
  CompositeScopedContextProvider
} from "./P7GR5CS5.js";
import {
  createStoreContext
} from "./LMDWO4NN.js";

// src/menubar/menubar-context.tsx
import { createContext } from "react";
var menubar = createStoreContext(
  [CompositeContextProvider],
  [CompositeScopedContextProvider]
);
var useMenubarContext = menubar.useContext;
var useMenubarScopedContext = menubar.useScopedContext;
var useMenubarProviderContext = menubar.useProviderContext;
var MenubarContextProvider = menubar.ContextProvider;
var MenubarScopedContextProvider = menubar.ScopedContextProvider;
var MenuItemCheckedContext = createContext(
  void 0
);

export {
  useMenubarContext,
  useMenubarScopedContext,
  useMenubarProviderContext,
  MenubarContextProvider,
  MenubarScopedContextProvider,
  MenuItemCheckedContext
};
